import React from 'react';
export function BonusSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-44">
      <div className="max-w-5xl mx-auto" data-id="element-45">
        <div className="text-center mb-16" data-id="element-46">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-47">
            🎁 Bonos especiales incluidos hoy
          </h2>
          <p className="text-2xl text-red-600 font-black uppercase tracking-wider" data-id="element-48">
            (Sin costo adicional)
          </p>
        </div>

        <div className="space-y-16" data-id="element-49">
          {/* Bono 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-200 flex flex-col md:flex-row items-center gap-8" data-id="element-50">
            <div className="w-full md:w-1/2" data-id="element-51">
              <a href="#compra" onClick={scrollToPricing} className="block cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-52">
                <img src="https://cdn.magicpatterns.com/uploads/fEm66h1L6sMERDTAJLtTgY/bono_1.png" alt="Bono 1 - Planificador Reset 30D" className="w-full max-w-[1080px] mx-auto rounded-xl shadow-md" data-id="element-53" />
              </a>
            </div>
            <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-54">
              <div className="inline-block bg-red-100 text-red-800 font-bold px-4 py-1 rounded-full mb-4 border border-red-200" data-id="element-55">
                🎁 Bono #1
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-4" data-id="element-56">
                Planificador Reset 30D
              </h3>
              <p className="text-xl text-gray-700 mb-6" data-id="element-57">
                Sistema de seguimiento diario + tracker de hábitos.
              </p>
              <div className="text-2xl font-black text-green-600 bg-green-50 inline-block px-6 py-2 rounded-lg border-2 border-green-200" data-id="element-58">
                HOY: GRATIS
              </div>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-200 flex flex-col md:flex-row-reverse items-center gap-8" data-id="element-59">
            <div className="w-full md:w-1/2" data-id="element-60">
              <a href="#compra" onClick={scrollToPricing} className="block cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-61">
                <img src="https://cdn.magicpatterns.com/uploads/vnLYNaoGXBxjkfPzNxpzE7/bono_2.png" alt="Bono 2 - Recetario Express" className="w-full max-w-[1080px] mx-auto rounded-xl shadow-md" data-id="element-62" />
              </a>
            </div>
            <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-63">
              <div className="inline-block bg-red-100 text-red-800 font-bold px-4 py-1 rounded-full mb-4 border border-red-200" data-id="element-64">
                🎁 Bono #2
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-4" data-id="element-65">
                Recetario Express RESET 30D
              </h3>
              <p className="text-xl text-gray-700 mb-6" data-id="element-66">
                Recetas listas en 20 minutos o menos para mantener tu déficit
                sin complicaciones.
              </p>
              <div className="text-2xl font-black text-green-600 bg-green-50 inline-block px-6 py-2 rounded-lg border-2 border-green-200" data-id="element-67">
                HOY: GRATIS
              </div>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-200 flex flex-col md:flex-row items-center gap-8" data-id="element-68">
            <div className="w-full md:w-1/2" data-id="element-69">
              <a href="#compra" onClick={scrollToPricing} className="block cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-70">
                <img src="https://cdn.magicpatterns.com/uploads/p3NVC1EPvFwRhRgDPrQfdg/bono_3.png" alt="Bono 3 - Guía Inteligente" className="w-full max-w-[1080px] mx-auto rounded-xl shadow-md" data-id="element-71" />
              </a>
            </div>
            <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-72">
              <div className="inline-block bg-red-100 text-red-800 font-bold px-4 py-1 rounded-full mb-4 border border-red-200" data-id="element-73">
                🎁 Bono #3
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-4" data-id="element-74">
                Guía Inteligente para Comer Fuera
              </h3>
              <p className="text-xl text-gray-700 mb-6" data-id="element-75">
                Estrategias claras para restaurantes y eventos sociales sin
                sabotear resultados.
              </p>
              <div className="text-2xl font-black text-green-600 bg-green-50 inline-block px-6 py-2 rounded-lg border-2 border-green-200" data-id="element-76">
                HOY: GRATIS
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}